import { getSavedState, saveState } from "@/helpers/LocalStorage.js";

// Cómo se ve el panel: lo elige cada vendedor y queda en este navegador.
//
// El tamaño, en pantallas grandes (en el teléfono siempre es pantalla
// completa).
export const LAYOUTS = [
  { value: "floating", label: "Flotante", icon: "mdi-dock-window" },
  { value: "tall", label: "Todo el alto", icon: "mdi-dock-right" },
  { value: "fullscreen", label: "Pantalla completa", icon: "mdi-fullscreen" }
];

const LAYOUT_KEY = "assistant.layout";

export function getLayout() {
  const saved = getSavedState(LAYOUT_KEY);
  return LAYOUTS.some(layout => layout.value === saved) ? saved : "floating";
}

export function setLayout(value) {
  try {
    saveState(LAYOUT_KEY, value);
  } catch (e) {
    // Sin localStorage (navegación privada, cuota): vale hasta recargar
  }
}

// Acoplado ("Todo el alto") es parte de la pantalla: si se dejó abierto, se
// vuelve a abrir al recargar o al cambiar de tienda o departamento
const DOCKED_OPEN_KEY = "assistant.dockedOpen";

export function getDockedOpen() {
  return getSavedState(DOCKED_OPEN_KEY) === true;
}

export function setDockedOpen(open) {
  try {
    saveState(DOCKED_OPEN_KEY, open);
  } catch (e) {
    // Sin localStorage: se abre a mano
  }
}

// El tamaño de la letra de la conversación, como factor sobre el normal
export const TEXT_SCALES = [0.85, 1, 1.15, 1.3, 1.5];

const TEXT_SCALE_KEY = "assistant.textScale";

export function getTextScale() {
  const saved = getSavedState(TEXT_SCALE_KEY);
  return TEXT_SCALES.includes(saved) ? saved : 1;
}

export function setTextScale(value) {
  try {
    saveState(TEXT_SCALE_KEY, value);
  } catch (e) {
    // Sin localStorage: vale hasta recargar
  }
}
